module.exports = __webpack_public_path__ + "static/img/메달-생태자원.9448066.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/메달-생태자원.png
// module id = Q84D
// module chunks = 0